import React from 'react'
import { MainContainer } from '@core/Components/Containers'
import { PageHeader } from '@mobi/component-library/Navigation/PageHeader'
import { SearchProfiles } from '@core/Areas/BetLoop/Components/SearchProfiles'

export const SearchProfilesPage = () => {

  return (
    <MainContainer background='surface300'>
      <PageHeader title='Find Profiles' />
      <SearchProfiles />
    </MainContainer>
  )
}
